import React, { useState } from "react";
import Alert from "@material-ui/lab/Alert";
import {cloudFunctions} from "../../../firebase"
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

const DeleteAccount = ({currentUser}) => {
  const title = "Remove Account";

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [inSubmit, setInSubmit] = useState(false);

  let endDate = null
  if(currentUser.paymentType && currentUser.paymentType === "paypal") {
    endDate = new Date(currentUser.billing_info.next_billing_time).toLocaleDateString()
  } else {
    endDate = new Date(currentUser.subscription.trial_end * 1000).toLocaleDateString()
  }

  const onDeleteAccount = e => {
    setInSubmit(true);
    if(currentUser.paymentType && currentUser.paymentType === "paypal") {
      const deletePaypalSubscription = cloudFunctions.httpsCallable(
        "deletePaypalSubscription"
      );
      deletePaypalSubscription({
        accountId: currentUser.email,
      })
        .then((res) => {
          setInSubmit(false);
          setSuccess(true);
          window.location.replace("/")
        })
        .catch((err) => {
          setInSubmit(false);
          setError(err.message);
        });
      return;
    }
    
    const deleteSubscription = cloudFunctions.httpsCallable(
      "deleteSubscription"
    );
    deleteSubscription({
      accountId: currentUser.uid,
    })
      .then((res) => {
        setInSubmit(false);
        setSuccess(true);
        window.location.replace("/")
      })
      .catch((err) => {
        setInSubmit(false);
        setError(err.message);
      });
  }

  return (
    <div className="container-fluid">
    <Backdrop open={inSubmit} style={{ zIndex: 10000 }}>
      <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
    </Backdrop>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">{title}</div>
          <div className="card-body">
            {error !== null && (
              <Alert type="severity">{error}</Alert>
            )}
            <p>
              Your current subscription period will end on{" "}
              {endDate}
              . The system will charge USD{" "}
              3.99$/month to renew the subscription.
              Deleting the account will stop the subscription and remove your account.
            </p>
            <p className="text-danger">
              Are you sure you want to remove your account?
            </p>
            <button
              className="btn btn-danger mr-3"
              disabled={inSubmit ? true : false}
              onClick={(e) => onDeleteAccount(e)}
            >
              Yes, I want to remove my account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
